import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { handleDataGridExport } from "../../../../common/Utils";
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import SearchLayout from './TransactionProfileSearchLayout';
import {
  Column,
  DataGrid,
  GroupPanel,
  Scrolling,
  Grouping,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber } from '../../../../common/Utils'
import '../../../../common/css/searchPage.css';
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

const SearchTransactionProfiles = (props) => {
  const dataGrid = useRef(null);
  const history = useHistory();
  const allowAvl = [
    { ID: "A", Name: "No, Net Item Available Quantity Must Be = OR > Shipment Quantity" },
    { ID: "N", Name: "No, Item Available Quantity Must Be = OR > Shipment Quantity" },
    { ID: "Y", Name: "Yes, Allow Shipment Regardless Of Item Available Quantity" },
    { ID: "C", Name: "Yes, Allow Shipment Regardless Of Item Net Available Quantity" }
  ];
  const estData = [
    { ID: "Y", Name: "Yes, calculate estimated weights at pending stage" },
    { ID: "N", Name: "No, donot calculate estimated weights at pending stage" },
  ];
  const uservalidationoncommitData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];
  const allowuservalidationData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];
  const navReportStatus = [
    { ID: "A", Name: "Active" },
    { ID: "I", Name: "Inactive" },
  ];
  const navReportType = [
    { ID: "R", Name: "ABECAS Insight Report" },
    { ID: "T", Name: ".Net Report" },
  ];

  const itemCharges = [
    { ID: "Y", Name: "Yes - Create Item Charges" },
    { ID: "N", Name: "No - Do not Create Item Charges" },
  ];


  const netAvail = [
    { ID: "Y", Name: "Yes, allow ordered qty > net avail at Pending Stage" },
    { ID: "N", Name: "No, do not allow ordered qty > net avail at pending stage" },
    { ID: "A", Name: "No, do not allow quantity > net available less pending receipts" },
  ];
  const showshipperonreceiptData = [
    { ID: "Y", Name: "Yes Standard Entry" },
    { ID: "N", Name: "No" },
  ];
  const availableDateLookupData = [
    { ID: "N", Name: "No, do not update - only during initial creation" },
    { ID: "I", Name: "Update item/lot/sublot available and storage billing start date fields" },
    { ID: "L", Name: "Update lot/sublot available and storage billing start date fields" },
    { ID: "S", Name: "Update sublot available and storage billing start date fields" },
  ];
  const RfTransactionData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];
  const poReferenceData = [
    { ID: "B", Name: "Warn Only, Allow Duplicate PO/Reference # By Customer" },
    { ID: "A", Name: "No, Do Not Allow Duplicate PO/Reference # By Customer" },
    { ID: "Y", Name: "Yes, Allow Duplicate PO/Reference #" },
    { ID: "N", Name: "No, Do Not Allow Duplicate PO/Reference #" },
    { ID: "W", Name: "Warn Only, Allow Duplicate PO/Reference #" },
  ];
  const screenTotalData = [
    { ID: "A", Name: "Standard" },
    { ID: "B", Name: "Do not include Free Days" },
  ];
  const updateudfieldsData = [
    { ID: "L", Name: "Update Lot's User Defined Fields" },
    { ID: "N", Name: "Do Not Update" },
  ];
  const detailudfieldsData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No Defaults" },
  ];
  const splitordersourcefieldData = [
    { ID: "S", Name: "Shipper/BOL #" },
    { ID: "T", Name: "Transaction#" },
  ];
  const lotstoragedateData = [
    { ID: "Y", Name: "Yes, default Item/Lot/Sublot storage start date to Receipt Date	Transaction" },
    { ID: "N", Name: "No. do not default Item/Lot/Sublot storage start date" },
  ];
  const stagingdatetimedefaultData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No Do Not Default" },
  ];
  const splitorderData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];
  const orderNotEqualToAccLookupdata = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No[Default]" },
  ];
  const optionsYesNo = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];

  const optionsYesNoData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];
  const userValidationCommitData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];
  const showserialnopopupData = [
    { ID: "Y", Name: "Yes" },
    { ID: "N", Name: "No" },
  ];

  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchPanelStatus, setSearchPanelStatus] = useState(false);
  const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
  const rowId = useRef(null);
  const [currentLayout, setCurrentLayout] = useState("Default");
  const allowedPageSizes = [10, 20, 100, 500];
  const gridKey = "100A77DC-B526-470A-85C3-014A35E3A7CF";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); }, []);
  const initialFormFields = {
    PROFILECODE: '',
    USERDEFINEDCODE_1: '',
    CREATIONUSERID: '',
    ALLOWDUPLICATEPO: '',
    SUBLOT_ALTERNATEIDMETHOD: '',
    DESCRIPTION: '',
    USERDEFINEDCODE_2: '',
    LASTUPDATEUSERID: '',
    DUPLICATESUBLOT: '',
    TRANSACTIONPREFIX: '',
    USERDEFINEDCODE_3: '',
    USERDEFINEDCODE_4: '',
    ARCOMMITMETHOD: '',
    USECRATE: '',
    WORKUNITUOM: '',
    USERDEFINEDCODE_5: '',
    SHIPMENTSONNEG_AVL: '',
    OPENITEMREFERENCE: '',
    KEYSEQUENCE: '',
    CREATIONDATETIME: '',
    CREATIONUSERID: '',
    LASTUPDATEDATETIME: '',
    LASTUPDATEUSERID: '',
    COMMITDATEOPTION: '',
    IDTYPE: props.IdType
  };
  const [formFields, setformFields] = useState(initialFormFields);

  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length == 1) {
      rowId.current = selectedRowsData[0].rowid;
    }
    else {
      rowId.current = '';
    }

    setIsEditButtonDisabled(!isEditButtonDisabled);
  };

  const handelEditClick = () => {
    const buttonUrl = "/wm/transactionprofile/edit-transaction?id=" + rowId.current;
    history.push(buttonUrl);
  };

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        return newStatus;
      });
    },
    [selectedItems, setSelectedItems],
  );

  const handleSearch = (e) => {
    e.event.stopPropagation();
    let datasource = loadDatasource();
    console.log("datasource:", datasource);
    const { IDTYPE, ...filteredFormFields } = formFields;
    const filters = FillFilters(filteredFormFields);
    console.log("filters:", filters);
    if (filters && filters.length > 0) {
      datasource.filter(filters);
    }
    setResultData(datasource);
  }
  const handleReset = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
    let datasource = loadDatasource();
    setResultData(datasource);
  }
  useEffect(() => {
    let datasource = loadDatasource();
    setResultData(datasource);
  }, []);

  const handleFormLoad = useCallback(() => {
    loadFromLookupClient("showserialnopopup", showserialnopopupData);
    loadFromLookupClient("useonessccpertrans", showserialnopopupData);
    loadFromLookupClient("uservalidationoncommit", userValidationCommitData);
    loadFromLookupClient("isplaceholderrecord", optionsYesNoData);
    loadFromLookupClient("rftransaction", RfTransactionData);
    loadFromLookupClient("allowduplicatepo", poReferenceData);
    loadFromLookupClient("validateactrecshipdt", allowuservalidationData);
    loadFromLookupClient("shipmentqtychkondtlsave", orderNotEqualToAccLookupdata);
    loadFromLookupClient("navreporT1STATUS", navReportStatus);
    loadFromLookupClient("navreporT1TYPE", navReportType);
    loadFromLookupClient("navreporT2STATUS", navReportStatus);
    loadFromLookupClient("navreporT2TYPE", navReportType);
    loadFromLookupClient("navreporT3STATUS", navReportStatus);
    loadFromLookupClient("ownrtransfrcrtchrgs", itemCharges);
    loadFromLookupClient("navreporT3TYPE", navReportType);
    loadFromLookupClient("navreporT4STATUS", navReportStatus);
    loadFromLookupClient("navreporT4TYPE", navReportType);
    loadFromLookupClient("esitmatedweight", estData);
    loadFromLookupClient("lotstoragedate", lotstoragedateData);
    loadFromLookupClient("splitordersourcefield", splitordersourcefieldData);
    loadFromLookupClient("splitorder", splitorderData);
    loadFromLookupClient("stagingdatetimedefault", stagingdatetimedefaultData);
    loadFromLookupClient("screentotals", screenTotalData);
    loadFromLookupClient("detailudfields", detailudfieldsData);
    loadFromLookupClient("updateudfields", updateudfieldsData);
    loadFromLookupClient("shipmentsonneT_AVL", netAvail);
    loadFromLookupClient("showshipperonreceipt", showshipperonreceiptData);
    var codesDataSource1 = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
        loadParams: {
          codeType: function () {
            return "57";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });
    loadLookupFromDataSource("USERDEFINEDCODE_1", codesDataSource1, 'name', 'name');
    var codesDataSource2 = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
        loadParams: {
          codeType: function () {
            return "58";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });
    loadLookupFromDataSource("USERDEFINEDCODE_2", codesDataSource2, 'name', 'name');
    var codesDataSource3 = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
        loadParams: {
          codeType: function () {
            return "59";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });
    loadLookupFromDataSource("USERDEFINEDCODE_3", codesDataSource3, 'name', 'name');
    var codesDataSource4 = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
        loadParams: {
          codeType: function () {
            return "60";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });
    loadLookupFromDataSource("USERDEFINEDCODE_4", codesDataSource4, 'name', 'name');
    var codesDataSource5 = new DataSource({
      store: new createStore({
        key: 'id',
        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
        loadParams: {
          codeType: function () {
            return "61";
          }
        },
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
      paginate: true,
      pageSize: 100,
      sort: [
        {
          selector: "name",
          desc: false,
        }
      ],
    });
    loadLookupFromDataSource("USERDEFINEDCODE_5", codesDataSource5, 'name', 'name');

    var optionsYesNo = [{ "Rowid": "Y", "Code": "Yes, Allow Duplicate PO/Reference #" }
      , { "Rowid": "N", "Code": "No, Do Not Allow Duplicate PO/Reference #" },
    { "Rowid": "W", "Code": "Warn Only, Allow Duplicate PO/Reference #" }];
    loadClientLookup("ALLOWDUPLICATEPO", poReferenceData);
    loadClientLookup("SHIPMENTSONNEG_AVL", allowAvl);
    optionsYesNo = [{ "Rowid": "Y", "Code": "Yes, Allow Same Sublot Code Multiple Receipts" },
    { "Rowid": "N", "Code": "No, Do Not Allow Same Sublot Code In Multiple Receipts" },
    { "Rowid": "W", "Code": "Yes, Allow Same Sublot Code For Multiple Receipts W/Warning" }];
    loadLookupClient("DUPLICATESUBLOT", optionsYesNo);

    var data = [{ "Rowid": "Y", "Code": "Yes, Crate Tracking Is Used In Transaction Entry" }
      , { "Rowid": "N", "Code": "No, Crate Tracking Is Used In Transaction Entry" },
    ];
    loadLookupClient("USECRATE", data);

    data = [{ "Rowid": "Y", "Code": "Yes, Auto Generate Alternate ID" }
      , { "Rowid": "N", "Code": "No, Do Not Auto Generate Alternate ID" },
    ];
    loadLookupClient("SUBLOT_ALTERNATEIDMETHOD", data);






  }, []);

  const loadClientLookup = (name, data) => {
    try {
      const newOptions = data.map(item => ({
        id: item.ID,
        name: item.Name
      }));
      if (formRefs.current[name]) {

        formRefs.current[name].instance().option('dataSource', newOptions);
        formRefs.current[name].instance().option('valueExpr', 'id');
        formRefs.current[name].instance().option('displayExpr', 'name');
      }
    } catch (error) {
      console.error('Error fetching item detail:', error);
    } finally {
    }
  };
  const loadFromLookupClient = (name, data) => {
    try {
      const newOptions = data.map(item => ({
        id: item.ID,
        name: item.Name
      }));
      if (formRefs.current[name]) {

        formRefs.current[name].instance().option('dataSource', newOptions);
        formRefs.current[name].instance().option('valueExpr', 'id');
        formRefs.current[name].instance().option('displayExpr', 'name');
      }
    } catch (error) {
      console.error('Error fetching item detail:', error);
    } finally {
    }
  };
  const loadLookupClient = (name, data) => {
    try {
      const newOptions = data.map(item => ({
        id: item.Rowid,
        name: item.Code
      }));
      if (formRefs.current[name]) {

        formRefs.current[name].instance().option('dataSource', newOptions);
        formRefs.current[name].instance().option('valueExpr', 'name');
        formRefs.current[name].instance().option('displayExpr', 'name');
      }
    } catch (error) {
      console.error('Error fetching item detail:', error);
    } finally {
    }
  };
  const loadLookupFromDataSource = (name, dataSource, valueExpr, displayExpr) => {
    if (formRefs.current[name]) {
      formRefs.current[name].instance().option('dataSource', dataSource);
      formRefs.current[name].instance().option('valueExpr', valueExpr);
      formRefs.current[name].instance().option('displayExpr', displayExpr);
    }
    else {
      console.log('not found control:');
    }
  };

  const handleFieldChange = useCallback((name, value) => {
    // console.log(name, value);
  }, []);
  const loadDatasource = () => {
    var url = "wm/TransactionDataProfile/GetTransactionDataProfiles";
    let store = createStore({
      key: 'rowid',
      loadParams: formFields,
      loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    const dataSource = new DataSource({ store: store });
    dataSource.sort([
      { selector: 'keysequence', desc: false },
    ]);
    return dataSource;
  }
  const [resultData, setResultData] = useState(null);

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={e => {
              if (e.currentTarget === e.target) {
                selectionChanged(e, e.target);
              }
            }}
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6
                      style={{
                        color: window._env_.Color2
                      }}
                    >
                      Enter Transaction Profiles
                    </h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleReset} text="Reset" />
                </Item>
              </Toolbar>
            )}
            itemRender={(itemProps) => (
              <FormField
                currrentUser={currentUser}
                layoutId='58dfc264-a700-4e77-ae3f-8431b1b92c56'
                layoutName='WMTransactionDataEntrySearchForm'
                defaultFormSchema={SearchLayout}
                formFields={formFields}
                setformFields={setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
                noSpacingBeforeFirstRow={true}
              />
            )}
            id="accordion-container" className="accordion-height"
          />
        </div>
        <div className="search-page-grid-container">
          <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
            allowColumnReordering={true}
            allowColumnResizing={true}
            dataSource={resultData}
            showBorders={true}
            hoverStateEnabled={true}
            className="search-page-grid"
            onSelectionChanged={(e) => onSelectionChanged(e)}
            remoteOperations={true}
            searchEnabled={true}
            columnAutoWidth={true}
          >
                <ColumnChooser
                  enabled={true}
                  title="Choose Column"
                  width={290}
                  height={290}
                  sortOrder="asc"
                >
                  <ColumnChooserSearch
                      enabled={true}
                      editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>

                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="multiple" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                  visible={true}
                  showPageSizeSelector={true}
                  allowedPageSizes={allowedPageSizes}
                  showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />

                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                  enabled={true}
                  type="custom"
                  customLoad={loadState}
                  storageKey={gridKey}
                  customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="workunituom" caption="Work UOM" visible={false} ></Column>
                <Column dataField="profilecode" caption="Profile" ></Column>
                <Column dataField="description" caption="Description" ></Column>
                <Column dataField="transactionprefix" caption="Prefix" ></Column>
                <Column dataField="populatelotwithcarrier" caption="Carrier Info" ></Column>
                <Column dataField="shippernogeneration" caption="Shipper Generation"  ></Column>
                <Column dataField="lastupdatedatetime" caption="Last updated"
                  dataType="date"
                  format="MM/dd/yyyy hh:mm:ss aa"
                ></Column>
                <Column dataField="shipmentsonneG_AVL" caption="Allow(-)-Avi" >
                  <Lookup
                    dataSource={allowAvl}
                    valueExpr="ID"
                    displayExpr="Name"
                  />

                </Column>
                <Column dataField="printsscclabel" caption="Print SSCC Label" ></Column>
                <Column dataField="printserialnumberlabel" caption="Print Serial# Label"
                ></Column>
                <Column dataField="printpickingslipsequence" caption="Print Picking Slip Sequence" ></Column>
                <Column dataField="datevalidation" caption="Date Validation" dataType="date"

                  format="MM/dd/yyyy hh:mm:ss aa"></Column>
                <Column dataField="showserialnopopup" caption="Show Serial# Popup" visible={false}>
                  <Lookup
                    dataSource={showserialnopopupData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />

                </Column>
                <Column dataField="isplaceholderrecord" caption="Placeholder" visible={false}>
                  <Lookup
                    dataSource={optionsYesNoData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>

                <Column dataField="keysequence" caption="Record#" visible={false}></Column>
                <Column dataField="creationdatetime" caption="Creation Date"
                  dataType="date"
                  format="MM/dd/yyyy hh:mm:ss aa"
                  visible={false}></Column>
                <Column dataField="creationuserid" caption="Created By" visible={false}></Column>

                <Column dataField="lastupdateuserid" caption="Last Updated By" visible={false}></Column>


                <Column dataField="commitdateoption" caption="Commit Date"
                  dataType="date"
                  format="MM/dd/yyyy hh:mm:ss aa"
                  visible={false}></Column>
                <Column dataField="arcommitmethod" caption="Commit Basis"

                  visible={false}></Column>
                <Column dataField="rftransaction" caption="RFTRANSACTION" visible={false}>
                  <Lookup
                    dataSource={RfTransactionData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="rfgrouP_FULLQTY" caption="RF/Group When Full Qty" visible={false}></Column>
                <Column dataField="rfgrouP_PARTIALQTY" caption="RF/Group When Partial Qty" visible={false}></Column>
                <Column dataField="comment" caption="Comment" visible={false}></Column>
                <Column dataField="openitemreference" caption="Reference#" visible={false}></Column>
                <Column dataField="allowduplicatepo" caption="PO/Reference" visible={false}>
                  <Lookup
                    dataSource={poReferenceData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>

                <Column dataField="userdefinedcodE_1" caption="Code 1" visible={false}></Column>
                <Column dataField="userdefinedcodE_2" caption="Code 2" visible={false}></Column>
                <Column dataField="userdefinedcodE_3" caption="Code 3" visible={false}></Column>
                <Column dataField="userdefinedcodE_4" caption="Code 4" visible={false}></Column>
                <Column dataField="userdefinedcodE_5" caption="Code 5" visible={false}></Column>
                <Column dataField="autogenerateserialnumber" caption="Auto Generate Serial#" visible={false}></Column>
                <Column dataField="duplicatesublot" caption="Sublot" visible={false}></Column>
                <Column dataField="usecrate" caption="Use Crate" visible={false}></Column>
                <Column dataField="uservalidationoncommit" caption="User Validation Commit" visible={false}>
                  <Lookup
                    dataSource={uservalidationoncommitData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="validateactrecshipdt" caption="Validate" visible={false}>
                  <Lookup
                    dataSource={allowuservalidationData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />

                </Column>
                <Column dataField="subloT_ALTERNATEIDMETHOD" caption="Alternate ID" visible={false}></Column>
                <Column dataField="allowblanklocations" caption="Blank Location" visible={false}></Column>
                <Column dataField="locationmethoD_RECEIPTS" caption="Location" visible={false}></Column>
                <Column dataField="plandatetimedefault" caption="Plan Appt Date Time" visible={false}></Column>
                <Column dataField="navreporT1FORMAT" caption="Rpt1 Format" visible={false}></Column>
                <Column dataField="navreporT1NAME" caption="Rpt1 Name" visible={false}></Column>
                <Column dataField="navreporT1STATUS" caption="Rpt1 Status" visible={false}>
                  <Lookup
                    dataSource={navReportStatus}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT1TEXT" caption="Rpt1 Text" visible={false}></Column>
                <Column dataField="navreporT1TYPE" caption="Rpt1 Type" visible={false}>
                  <Lookup
                    dataSource={navReportType}
                    valueExpr="ID"
                    displayExpr="Name"
                  />

                </Column>

                <Column dataField="navreporT2STATUS" caption="Rpt2 Status" visible={false}>
                  <Lookup
                    dataSource={navReportStatus}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT2TEXT" caption="Rpt2 Text" visible={false}></Column>
                <Column dataField="navreporT2TYPE" caption="Rpt2 Type" visible={false}>
                  <Lookup
                    dataSource={navReportType}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT2NAME" caption="Rpt2 Name" visible={false}></Column>
                <Column dataField="navreporT2FORMAT" caption="Rpt2 Format" visible={false}></Column>

                <Column dataField="navreporT3STATUS" caption="Rpt3 Status" visible={false}>
                  <Lookup
                    dataSource={navReportStatus}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT3TEXT" caption="Rpt3 Text" visible={false}></Column>
                <Column dataField="navreporT3TYPE" caption="Rpt3 Type" visible={false}>
                  <Lookup
                    dataSource={navReportType}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT3NAME" caption="Rpt3 Name" visible={false}></Column>
                <Column dataField="navreporT3FORMAT" caption="Rpt3 Format" visible={false}></Column>

                <Column dataField="navreporT4STATUS" caption="Rpt4 Status" visible={false}>
                  <Lookup
                    dataSource={navReportStatus}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT4TEXT" caption="Rpt4 Text" visible={false}></Column>
                <Column dataField="navreporT4TYPE" caption="Rpt4 Type" visible={false}>
                  <Lookup
                    dataSource={navReportType}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="useonessccpertrans" caption="Use 1 SSCC" visible={false}> 
                  <Lookup
                    dataSource={optionsYesNo}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="navreporT4NAME" caption="Rpt4 Name" visible={false}></Column>
                <Column dataField="navreporT4FORMAT" caption="Rpt4 Format" visible={false}></Column>
                <Column dataField="esitmatedweight" caption="Estimated Wt" visible={false}>
                  <Lookup
                    dataSource={estData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="actrecshipdtdaysahead" caption="Days Ahead" visible={false}></Column>
                <Column dataField="actrecshipdtdaysbehind" caption="Days Behind" visible={false}></Column>
                <Column dataField="lotexpirationdatecheck" caption="Lot Expiration Date Check" visible={false}></Column>
                <Column dataField="generateinspection" caption="Inspection" visible={false}></Column>
                <Column dataField="reasonmandatory" caption="Reason Mandatory" visible={false}></Column>


                <Column dataField="lotstoragedate" caption="Storage Date" dataType="date"
                  visible={false}
                >
                  <Lookup
                    dataSource={lotstoragedateData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>

                <Column dataField="lotavailabledate" caption="Available Date" visible={false}>
                  <Lookup
                    dataSource={availableDateLookupData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>

                <Column dataField="shipmentqtychkondtlsave" caption="Ordered <> Act" visible={false}>
                  <Lookup
                    dataSource={orderNotEqualToAccLookupdata}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="splitordersourcefield" caption="Split Order Source" visible={false}>
                  <Lookup
                    dataSource={splitordersourcefieldData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>

                <Column dataField="creditcheckonstagechange" caption="On Stage" visible={false}></Column>
                <Column dataField="splitorder" caption="Split Receipt" visible={false}>
                  <Lookup
                    dataSource={splitorderData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="stagingdatetimedefault" caption="Staging D/T" visible={false}>
                  <Lookup
                    dataSource={stagingdatetimedefaultData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="printserialnomanifestrev" caption="Print Serial# Manifest-Revised" visible={false}></Column>
                <Column dataField="printreceiptconfirmation" caption="Print Receipt Confirmation" visible={false}></Column>
                <Column dataField="oversellingwarning" caption="Over Selling" visible={false}></Column>
                <Column dataField="screentotals" caption="Screen Totals" visible={false}>
                  <Lookup
                    dataSource={screenTotalData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="detailudfields" caption="UD Feilds" visible={false}>
                  <Lookup
                    dataSource={detailudfieldsData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="updateudfields" caption="Update Info" visible={false}>
                  <Lookup
                    dataSource={updateudfieldsData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />

                </Column>
                <Column dataField="translocweight" caption="Trans Loc Weight" visible={false}></Column>
                <Column dataField="shipmentsonneT_AVL" caption="Ordered > Net Avail" visible={false}>
                  <Lookup
                    dataSource={netAvail}
                    valueExpr="ID"
                    displayExpr="Name"
                  />

                </Column>
                <Column dataField="showshipperonreceipt" caption="Show Shipper" visible={false}>
                  <Lookup
                    dataSource={showshipperonreceiptData}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="ownrtransfrcrtchrgs" caption="Item Charges" visible={false}>
                  <Lookup
                    dataSource={itemCharges}
                    valueExpr="ID"
                    displayExpr="Name"
                  />
                </Column>
                <Column dataField="popupmessageuser" caption="User Msg" visible={false}></Column>
                <Column dataField="ignoresamedayshiptime" caption="Ignore Time" visible={false}></Column>
                <Column dataField="populateactualrsdate" caption="Rec/Ship Dt" visible={false}></Column>
                <Column dataField="processdynevalcharges" caption="Dyn Chrgs" visible={false}></Column>
                <Column dataField="sublotverification" caption="Sublot Verify" visible={false}></Column>
                <Column dataField="receiptcommitorderedactual" caption="Receipt Qty" visible={false}></Column>
                <Column dataField="otcreateitemflag" caption="Create Items" visible={false}></Column>
                
                <Column dataField="transfertocompanyid" caption="To Company Id" visible={false}></Column>
                <Column dataField="status" caption="Status" visible={false}></Column>
                <GridToolbar>
                  <GridToolbarItem location="before">
                    <Button
                      disabled={isEditButtonDisabled}
                      onClick={handelEditClick}
                      type="default"
                      text="Edit"
                    ></Button>
                  </GridToolbarItem>
                  <GridToolbarItem location="before">
                    <div>
                      <Link to="/wm/transactionprofile/create-transaction">
                        <Button
                          type="default"
                          className="gridTopButton"
                          text="Create"
                        ></Button>
                      </Link>
                    </div>
                  </GridToolbarItem>
                  <GridToolbarItem location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </GridToolbarItem>
                  <GridToolbarItem name="exportButton" />
                  <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(SearchTransactionProfiles);